/**
 * Cascading Brand -> Model -> Year selector.
 * Reads the vehicle metaobject data embedded by sections/car-selector.liquid and
 * (when reused) sections/ppf-booking.liquid, both of which render a
 * <script type="application/json" data-vehicle-data> tag with the same shape.
 */
(function () {
  function getVehicles(root) {
    var node = root.querySelector('[data-vehicle-data]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      console.error('Carzelo: could not parse vehicle data', e);
      return [];
    }
  }

  function uniqueSorted(values) {
    return Array.from(new Set(values.filter(Boolean))).sort(function (a, b) {
      return a.localeCompare(b);
    });
  }

  function fillSelect(select, options, placeholder) {
    select.innerHTML = '';
    var placeholderOpt = document.createElement('option');
    placeholderOpt.value = '';
    placeholderOpt.textContent = placeholder;
    select.appendChild(placeholderOpt);
    options.forEach(function (opt) {
      var el = document.createElement('option');
      el.value = String(opt.value);
      el.textContent = opt.label;
      select.appendChild(el);
    });
  }

  function yearsInRange(from, to) {
    var years = [];
    from = parseInt(from, 10);
    to = parseInt(to, 10);
    if (!from || !to || to < from) return years;
    for (var y = to; y >= from; y--) years.push(y);
    return years;
  }

  function initCarSelector(root) {
    var vehicles = getVehicles(root);
    var brandSelect = root.querySelector('[data-car-brand]');
    var modelSelect = root.querySelector('[data-car-model]');
    var yearSelect = root.querySelector('[data-car-year]');
    var submitBtn = root.querySelector('[data-car-submit]');
    var form = root.querySelector('[data-car-selector-form]');
    var errorEl = root.querySelector('[data-car-selector-error]');
    if (!brandSelect || !modelSelect || !yearSelect || !form) return;

    var scriptTag = root.querySelector('script[src*="car-selector.js"]');
    var resultsUrl = form.dataset.resultsUrl || (scriptTag && scriptTag.getAttribute('data-results-url')) || '/pages/compatible-products';
    // data-always-active (Select-your-car section): the submit button is never disabled and goes as far
    // as the selection goes - nothing chosen browses everything, a partial car narrows the results page.
    var alwaysActive = form.hasAttribute('data-always-active');
    // data-allow-partial (results page finder): searchable once a brand is chosen; model and
    // year narrow further but aren't required.
    var allowPartial = form.hasAttribute('data-allow-partial');
    var browseUrl = form.dataset.browseUrl || '/collections/all';

    var brands = uniqueSorted(vehicles.map(function (v) { return v.brand; }));
    fillSelect(brandSelect, brands.map(function (b) { return { value: b, label: b }; }), brandSelect.querySelector('option').textContent);

    function updateModels() {
      var brand = brandSelect.value;
      var models = uniqueSorted(
        vehicles.filter(function (v) { return v.brand === brand; }).map(function (v) { return v.model; })
      );
      fillSelect(modelSelect, models.map(function (m) { return { value: m, label: m }; }), modelSelect.dataset.placeholder || modelSelect.options[0].textContent);
      modelSelect.disabled = !brand;
      yearSelect.disabled = true;
      fillSelect(yearSelect, [], yearSelect.options[0] ? yearSelect.options[0].textContent : '');
      updateSubmitState();
    }

    function updateYears() {
      var brand = brandSelect.value;
      var model = modelSelect.value;
      var matching = vehicles.filter(function (v) { return v.brand === brand && v.model === model; });
      var yearSet = new Set();
      matching.forEach(function (v) {
        yearsInRange(v.year_from, v.year_to).forEach(function (y) { yearSet.add(y); });
      });
      var years = Array.from(yearSet).sort(function (a, b) { return b - a; });
      fillSelect(yearSelect, years.map(function (y) { return { value: y, label: String(y) }; }), yearSelect.options[0] ? yearSelect.options[0].textContent : '');
      yearSelect.disabled = !model || years.length === 0;
      updateSubmitState();
    }

    function updateSubmitState() {
      var ready = allowPartial ? !!brandSelect.value : brandSelect.value && modelSelect.value && yearSelect.value;
      if (submitBtn) submitBtn.disabled = alwaysActive ? false : !ready;
    }

    brandSelect.addEventListener('change', updateModels);
    modelSelect.addEventListener('change', updateYears);
    yearSelect.addEventListener('change', updateSubmitState);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (alwaysActive || allowPartial) {
        if (errorEl) errorEl.textContent = '';
        if (!brandSelect.value) {
          if (alwaysActive) window.location.href = browseUrl;
          else if (errorEl) errorEl.textContent = 'Please select a brand';
          return;
        }
        var partial = new URLSearchParams({ brand: brandSelect.value });
        if (modelSelect.value) {
          partial.set('model', modelSelect.value);
          if (yearSelect.value) partial.set('year', yearSelect.value);
        }
        window.location.href = resultsUrl + '?' + partial.toString();
        return;
      }
      if (!brandSelect.value || !modelSelect.value || !yearSelect.value) {
        if (errorEl) errorEl.textContent = form.dataset.errorMessage || 'Please select brand, model and year';
        return;
      }
      if (errorEl) errorEl.textContent = '';
      var params = new URLSearchParams({
        brand: brandSelect.value,
        model: modelSelect.value,
        year: yearSelect.value
      });
      window.location.href = resultsUrl + '?' + params.toString();
    });

    // Deep-link support: ?brand=X[&model=Y[&year=Z]] pre-selects as far as the params go
    // (homepage brand cards link with brand only; the results page reflects its own URL).
    var urlParams = new URLSearchParams(window.location.search);
    var preselectBrand = (urlParams.get('brand') || '').trim();
    var preselectModel = (urlParams.get('model') || '').trim();
    var preselectYear = (urlParams.get('year') || '').trim();
    if (preselectBrand && brands.indexOf(preselectBrand) !== -1) {
      brandSelect.value = preselectBrand;
      updateModels();
      if (preselectModel && Array.prototype.some.call(modelSelect.options, function (o) { return o.value === preselectModel; })) {
        modelSelect.value = preselectModel;
        updateYears();
        if (preselectYear && Array.prototype.some.call(yearSelect.options, function (o) { return o.value === preselectYear; })) {
          yearSelect.value = preselectYear;
          updateSubmitState();
        }
      }
    }

    // Expose for reuse by ppf-booking.js (same markup pattern embedded in step 1).
    root.carzeloVehicles = vehicles;
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('#car-selector').forEach(initCarSelector);
  });

  window.CarzeloCarSelector = { init: initCarSelector, getVehicles: getVehicles, yearsInRange: yearsInRange, uniqueSorted: uniqueSorted };
})();
